// UUID & ULID Inspector Tool — validate and decode UUIDs and ULIDs.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const uuidInspectorTool: Tool = {
  id: "uuid-inspector",
  name: () => m.ud_tool_name(),
  description: () => m.ud_tool_description(),
  icon: "🆔",
  basePath: "/uuid-inspector",
  status: "stable",
  tags: ["uuid", "ulid", "inspect", "developer"],
  pages: [
    {
      name: () => m.ud_nav_main(),
      path: "/uuid-inspector",
      description: () => m.ud_nav_main_desc(),
      icon: "🆔",
    },
  ],
};
